import { toast } from 'sonner';

/**
 * Capture a DOM element as a PNG image and either copy it to clipboard
 * or download it as a file. Falls back gracefully on unsupported browsers.
 */
export async function copyElementAsImage(element, { filename = 'snapshot.png', copy = true } = {}) {
  if (!element) { toast.error('Nothing to capture'); return; }
  toast.info('Capturing image...');
  try {
    const html2canvas = (await import('html2canvas')).default;
    // Wide tables sit in horizontal scrollers on phones; widen the capture so every column (e.g. Cash/Bank/Total) is included.
    const scrollers = [...element.querySelectorAll('*')].filter((el) => ['auto', 'scroll'].includes(getComputedStyle(el).overflowX) && el.scrollWidth > el.clientWidth + 1);
    const width = Math.ceil(element.offsetWidth + Math.max(0, ...scrollers.map((el) => el.scrollWidth - el.clientWidth)));
    const canvas = await html2canvas(element, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      logging: false,
      width,
      windowWidth: Math.max(width, element.scrollWidth),
      onclone: (_doc, el) => {
        el.style.width = `${width}px`;
        el.querySelectorAll('*').forEach((c) => { if (['auto', 'scroll'].includes(c.ownerDocument.defaultView.getComputedStyle(c).overflowX)) c.style.overflow = 'visible'; });
      },
    });

    // Try clipboard first
    if (copy && navigator.clipboard && window.ClipboardItem) {
      try {
        const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
        toast.success('Copied! Paste into WhatsApp / Slack / Docs');
        return;
      } catch {
        // fall through to download
      }
    }

    // Fallback: trigger download
    const link = document.createElement('a');
    link.download = filename;
    link.href = canvas.toDataURL('image/png');
    link.click();
    toast.success('Image downloaded');
  } catch (err) {
    console.error(err);
    toast.error('Failed to capture');
  }
}
